import Main from "../Main";
import computeActiveTriggers from "./utils/compute-active-triggers";
import computeFinalWithInitial from "./utils/compute-final-with-initial";

/**
 * Run functions that compute percents and final property string
 * @this {MainClassProps}
 * @param {Number} now
 * @param {Boolean} isInitial
 */
Main.prototype.animate = function (now, isInitial) {
  if (!now && !isInitial) {
    return;
  }

  /** Get all active triggers and compute their flat values */
  computeActiveTriggers(this, now);

  /** Compute the final css */
  computeFinalWithInitial(this, isInitial);
};

export default Main.prototype.animate;
